import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import {
  GRID_AREA_ACTION,
  GRID_AREA_SUBTITLE,
  GRID_AREA_TITLE,
} from './constants';

export const Header = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  gridTemplateAreas: `
    "${GRID_AREA_TITLE} ${GRID_AREA_ACTION}"
    "${GRID_AREA_SUBTITLE} ${GRID_AREA_SUBTITLE}"
  `,
  alignItems: 'center',
});
